import React from 'react'
import { DemoContestList } from './list/page'

export const DemoContestPage: React.FC = () => {
  return <DemoContestList />
}
